module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-shadow box-shadow--big"
  }, [_c('div', {
    staticClass: "helper__wrapper"
  }, [_c('h6', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('SPECIFY_CHANGE_SIZE')))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row flex-center"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q2_1_sizeVal),
      expression: "s3q2_1_sizeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "3MM",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q2_1_sizeVal, "3MM")
    },
    on: {
      "change": [function($event) {
        _vm.s3q2_1_sizeVal = "3MM"
      }, function($event) {
        return _vm.updateSize(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('LIKE_PEPPER_SEED'))), _c('br'), _vm._v(_vm._s(_vm.$t('AROUND_VALUE_MM', {
    value: 3
  })))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q2_1_sizeVal),
      expression: "s3q2_1_sizeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "6MM",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q2_1_sizeVal, "6MM")
    },
    on: {
      "change": [function($event) {
        _vm.s3q2_1_sizeVal = "6MM"
      }, function($event) {
        return _vm.updateSize(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('LIKE_PEA_SEED'))), _c('br'), _vm._v(_vm._s(_vm.$t('AROUND_VALUE_MM', {
    value: 6
  })))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q2_1_sizeVal),
      expression: "s3q2_1_sizeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "12MM",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q2_1_sizeVal, "12MM")
    },
    on: {
      "change": [function($event) {
        _vm.s3q2_1_sizeVal = "12MM"
      }, function($event) {
        return _vm.updateSize(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('LIKE_NUT'))), _c('br'), _vm._v(_vm._s(_vm.$t('AROUND_VALUE_MM', {
    value: 12
  })))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q2_1_sizeVal),
      expression: "s3q2_1_sizeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "INNA",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q2_1_sizeVal, "INNA")
    },
    on: {
      "change": [function($event) {
        _vm.s3q2_1_sizeVal = "INNA"
      }, function($event) {
        return _vm.updateSize(true)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('OTHER_CHANGE')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [(_vm.showValueInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q2_1_sizeDescription),
      expression: "s3q2_1_sizeDescription"
    }],
    staticClass: "el-input__inner el-input__inner--small",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "5px",
      "width": "170px"
    },
    attrs: {
      "placeholder": _vm.$t('INSERT_SIZE'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.s3q2_1_sizeDescription)
    },
    on: {
      "change": _vm.updateDescription,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s3q2_1_sizeDescription = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('CLICK_ON_THE_PICTURE')))]), _vm._v(" "), _c('div', {
    staticClass: "select-img-container right-breast",
    style: ({
      height: '189px',
      width: _vm.canvasWidth
    })
  }, [_c('canvas', {
    staticClass: "canvas-cursor",
    attrs: {
      "id": "rightBreast",
      "width": "175",
      "height": "189px"
    },
    on: {
      "click": _vm.updateCanvas
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dac0338","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/helpers/right-breast-changes.vue
// module id = 1207
// module chunks = 0